// ENTITY fr.gestionpial.pial.dto.AeshListeDTO generated by ic2 no-version-available at Thu Oct 01 15:16:30 UTC 2026

import { mapping, fields } from '@ic2/ic2-lib';
import { NiveauClasse } from './NiveauClasse';

export class AeshListeDTO {

  static readonly __ic2_fqn: string = 'fr.gestionpial.pial.dto.AeshListeDTO';

  idAesh: number | null = 0;
  nom: string | null = '';
  prenom: string | null = '';
  email: string | null = '';
  volumeHoraireContrat: number | null = 0;
  niveauImpossible: NiveauClasse | null = null;
  aeshCo: boolean | null = false;
  totalAffecte: number | null = 0;
  totalReserve: number | null = 0;
  absent: boolean | null = false;
  ecoles: string[] | null = [];
  ecolesInterdites: string[] | null = [];
  ecolesPrioritaires: string[] | null = [];
  dateDebutContrat: Date | null = null;
  dateFinContrat: Date | null = null;

  constructor(init?:Partial<AeshListeDTO>) {
    Object.assign(this, init);
  }

  toString() {
    return JSON.stringify(this);
  }

}

mapping['fr.gestionpial.pial.dto.AeshListeDTO'] = AeshListeDTO;

fields['fr.gestionpial.pial.dto.AeshListeDTO']  = {
    idAesh: 'java.lang.Integer',
    nom: 'java.lang.String',
    prenom: 'java.lang.String',
    email: 'java.lang.String',
    volumeHoraireContrat: 'java.lang.Integer',
    niveauImpossible: 'fr.gestionpial.pial.entities.NiveauClasse',
    aeshCo: 'java.lang.Boolean',
    totalAffecte: 'java.lang.Integer',
    totalReserve: 'java.lang.Integer',
    absent: 'java.lang.Boolean',
    ecoles: 'java.util.List<java.lang.String>',
    ecolesInterdites: 'java.util.List<java.lang.String>',
    ecolesPrioritaires: 'java.util.List<java.lang.String>',
    dateDebutContrat: 'java.time.LocalDate',
    dateFinContrat: 'java.time.LocalDate'
};
